interface IIconProps {
  size?: number;
  color?: string;
}

export const LayerIcon = ({ size = 24 }: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="m19.474 12.838 1.697.835a1 1 0 0 1 0 1.795L13.32 19.33a3 3 0 0 1-2.649 0L2.82 15.468a1 1 0 0 1 0-1.795l1.697-.835 1.698.836-1.821.896 6.94 3.415a1.5 1.5 0 0 0 1.324 0l6.94-3.415-1.822-.896 1.7-.836ZM13.32 4.673l7.852 3.864a1 1 0 0 1 0 1.794l-7.852 3.864a3 3 0 0 1-2.649 0L2.82 10.33a1 1 0 0 1 0-1.794l7.851-3.864a3 3 0 0 1 2.65 0Zm-1.986 8.176a1.5 1.5 0 0 0 1.324 0l6.94-3.415-6.94-3.415a1.5 1.5 0 0 0-1.324 0l-6.94 3.415 6.94 3.415Z"
    ></path>
  </svg>
);

export const LayerForwardIcon = ({ size = 24 }: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M12.75 5.82v8.43a.75.75 0 1 1-1.5 0V5.81L8.99 8.07A.75.75 0 1 1 7.93 7l2.83-2.83a1.75 1.75 0 0 1 2.47 0L16.06 7A.75.75 0 0 1 15 8.07l-2.25-2.25zM15 10.48l6.18 3.04a1 1 0 0 1 0 1.79l-7.86 3.86a3 3 0 0 1-2.64 0l-7.86-3.86a1 1 0 0 1 0-1.8L9 10.49v1.67L4.4 14.4l6.94 3.42c.42.2.9.2 1.32 0l6.94-3.42-4.6-2.26v-1.67z"
    ></path>
  </svg>
);

export const LayerFrontIcon = ({ size = 24 }: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M12.75 3.82v9.43a.75.75 0 1 1-1.5 0V3.81L8.99 6.07A.75.75 0 1 1 7.93 5l2.83-2.83a1.75 1.75 0 0 1 2.47 0L16.06 5A.75.75 0 0 1 15 6.07l-2.25-2.25zM15 8.48l6.18 3.04a1 1 0 0 1 0 1.79l-7.86 3.86a3 3 0 0 1-2.64 0l-7.86-3.86a1 1 0 0 1 0-1.8L9 8.49v1.67L4.4 12.4l6.94 3.42c.42.2.9.2 1.32 0l6.94-3.42-4.6-2.26V8.48zm4.48 7.34 1.7.83a1 1 0 0 1 0 1.8l-7.86 3.86a3 3 0 0 1-2.64 0l-7.86-3.86a1 1 0 0 1 0-1.8l1.7-.83 1.7.83-1.82.9 6.94 3.41c.42.2.9.2 1.32 0l6.94-3.41-1.82-.9 1.7-.83z"
    ></path>
  </svg>
);

export const LayerBackwardIcon = ({ size = 24 }: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M12.75 18.12V9.75a.75.75 0 1 0-1.5 0v8.37l-2.26-2.25a.75.75 0 0 0-1.06 1.06l2.83 2.82c.68.69 1.79.69 2.47 0l2.83-2.82A.75.75 0 0 0 15 15.87l-2.25 2.25zM15 11.85v1.67l6.18-3.04a1 1 0 0 0 0-1.79l-7.86-3.86a3 3 0 0 0-2.64 0L2.82 8.69a1 1 0 0 0 0 1.8L9 13.51v-1.67L4.4 9.6l6.94-3.42c.42-.2.9-.2 1.32 0L19.6 9.6 15 11.85z"
    ></path>
  </svg>
);

export const LayerBackIcon = ({ size = 24 }: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="m19.48 10.82 1.7.83a1 1 0 0 1 0 1.8L15 16.49V14.8l4.6-2.26-1.82-.9 1.7-.83zm-14.96 0-1.7.83a1 1 0 0 0 0 1.8L9 16.49V14.8l-4.6-2.26 1.82-.9-1.7-.83zm8.23 9.5L15 18.07a.75.75 0 0 1 1.06 1.06l-2.83 2.83c-.68.68-1.79.68-2.47 0l-2.83-2.83a.75.75 0 0 1 1.06-1.06l2.26 2.26V6.9a.75.75 0 1 1 1.5 0v13.43zM15 11.35V9.68l4.6-2.27L12.66 4c-.42-.2-.9-.2-1.32 0L4.4 7.4 9 9.68v1.67L2.82 8.3a1 1 0 0 1 0-1.8l7.86-3.86a3 3 0 0 1 2.64 0l7.86 3.87a1 1 0 0 1 0 1.79L15 11.35z"
    ></path>
  </svg>
);

export const TextTabIcon = ({
  size = 24,
  color = 'currentColor',
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M18 5.5h-5.25V18c0 .28.22.5.5.5h2a.75.75 0 1 1 0 1.5h-6.5a.75.75 0 1 1 0-1.5h2a.5.5 0 0 0 .5-.5V5.5H6a.5.5 0 0 0-.5.5v1.25a.75.75 0 0 1-1.5 0V5.5C4 4.67 4.67 4 5.5 4h13c.83 0 1.5.67 1.5 1.5v1.75a.75.75 0 1 1-1.5 0V6a.5.5 0 0 0-.5-.5z"
    ></path>
  </svg>
);
export const AudioTabIcon = () => (
  <svg
    width="33"
    height="34"
    viewBox="0 0 33 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.54199 29.1875C10.7856 29.1875 12.6045 27.3687 12.6045 25.125C12.6045 22.8813 10.7856 21.0625 8.54199 21.0625C6.29834 21.0625 4.47949 22.8813 4.47949 25.125C4.47949 27.3687 6.29834 29.1875 8.54199 29.1875Z"
      stroke="white"
      strokeWidth="1.35417"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6045 25.1237V7.51953"
      stroke="white"
      strokeWidth="1.35417"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.8545 4.8125L12.6045 7.52083M28.8545 10.2292L12.6045 12.9375"
      stroke="white"
      strokeWidth="1.35417"
      strokeLinecap="round"
    />
    <path
      d="M24.791 26.4805C27.0347 26.4805 28.8535 24.6616 28.8535 22.418C28.8535 20.1743 27.0347 18.3555 24.791 18.3555C22.5474 18.3555 20.7285 20.1743 20.7285 22.418C20.7285 24.6616 22.5474 26.4805 24.791 26.4805Z"
      stroke="white"
      strokeWidth="1.35417"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.8545 22.4167V4.8125"
      stroke="white"
      strokeWidth="1.35417"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AudioDeleteIcon = () => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 1.5C3.5 1.10218 3.6475 0.720644 3.91005 0.43934C4.1726 0.158035 4.5287 0 4.9 0H9.1C9.4713 0 9.8274 0.158035 10.0899 0.43934C10.3525 0.720644 10.5 1.10218 10.5 1.5V3H13.3C13.4857 3 13.6637 3.07902 13.795 3.21967C13.9263 3.36032 14 3.55109 14 3.75C14 3.94891 13.9263 4.13968 13.795 4.28033C13.6637 4.42098 13.4857 4.5 13.3 4.5H12.5517L11.9448 13.6065C11.9197 13.9849 11.7616 14.3391 11.5025 14.5977C11.2434 14.8563 10.9024 15 10.5483 15H3.451C3.0969 15 2.75595 14.8563 2.49682 14.5977C2.23769 14.3391 2.07964 13.9849 2.0545 13.6065L1.449 4.5H0.7C0.514348 4.5 0.336301 4.42098 0.205025 4.28033C0.0737498 4.13968 0 3.94891 0 3.75C0 3.55109 0.0737498 3.36032 0.205025 3.21967C0.336301 3.07902 0.514348 3 0.7 3H3.5V1.5ZM4.9 3H9.1V1.5H4.9V3ZM2.8518 4.5L3.4517 13.5H10.549L11.1489 4.5H2.8518ZM5.6 6C5.78565 6 5.9637 6.07902 6.09497 6.21967C6.22625 6.36032 6.3 6.55109 6.3 6.75V11.25C6.3 11.4489 6.22625 11.6397 6.09497 11.7803C5.9637 11.921 5.78565 12 5.6 12C5.41435 12 5.2363 11.921 5.10503 11.7803C4.97375 11.6397 4.9 11.4489 4.9 11.25V6.75C4.9 6.55109 4.97375 6.36032 5.10503 6.21967C5.2363 6.07902 5.41435 6 5.6 6ZM8.4 6C8.58565 6 8.7637 6.07902 8.89497 6.21967C9.02625 6.36032 9.1 6.55109 9.1 6.75V11.25C9.1 11.4489 9.02625 11.6397 8.89497 11.7803C8.7637 11.921 8.58565 12 8.4 12C8.21435 12 8.0363 11.921 7.90503 11.7803C7.77375 11.6397 7.7 11.4489 7.7 11.25V6.75C7.7 6.55109 7.77375 6.36032 7.90503 6.21967C8.0363 6.07902 8.21435 6 8.4 6Z"
      fill="#FF7888"
    />
  </svg>
);

export const AudioPlayIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9467_27370)">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 16.5V7.5L16 12L10 16.5Z"
        fill="#D3D3D3"
        fillOpacity="0.7"
      />
    </g>
    <defs>
      <clipPath id="clip0_9467_27370">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AudioPauseIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9467_27364)">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 16H9V8H11V16ZM15 16H13V8H15V16Z"
        fill="#D3D3D3"
        fillOpacity="0.7"
      />
    </g>
    <defs>
      <clipPath id="clip0_9467_27364">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const ImageTabIcon = ({
  size = 24,
  color = 'currentColor',
}: IIconProps) => (
  <svg
    fill={color}
    preserveAspectRatio="xMidYMid meet"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M21,2H3A3,3,0,0,0,0,5V19a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V5A3,3,0,0,0,21,2ZM3,4H21a1,1,0,0,1,1,1v8l-2.23-1.94a4,4,0,0,0-5.45.19L11,14.59,9.83,13.41a4,4,0,0,0-5.66,0L2,15.59V5A1,1,0,0,1,3,4ZM22,19a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1v-.59l3.59-3.58a2,2,0,0,1,2.82,0l1.88,1.88a1,1,0,0,0,1.42,0l4-4a2,2,0,0,1,2.73-.09L22,15.67V19Z"></path>
      <circle cx="7" cy="8" r="2"></circle>
    </g>
  </svg>
);

export const GameTabIcon = ({
  size = 24,
  color = 'currentColor',
}: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.59047 12.5167C8.57457 12.5167 9.37234 11.7242 9.37234 10.7466C9.37234 9.76906 8.57457 8.97656 7.59047 8.97656C6.60637 8.97656 5.80859 9.76906 5.80859 10.7466C5.80859 11.7242 6.60637 12.5167 7.59047 12.5167Z"
      fill="white"
    />
    <path
      d="M16.5622 4C14.51 4 13.8618 5.8525 12 5.86165C10.1382 5.8525 9.49002 4 7.43779 4C3.38249 4 2 11.294 2 13.8881C2 16.4822 3.01382 19.5646 4.67281 19.5646C7.04147 19.5646 6.43932 16.0458 12 15.9665C17.5607 16.0458 16.9585 19.5646 19.3272 19.5646C20.9862 19.5646 22 16.4822 22 13.8881C22 11.294 20.6175 4 16.5622 4ZM7.5914 13.4303C6.09831 13.4303 4.88786 12.2279 4.88786 10.7447C4.88786 9.26146 6.09831 8.05901 7.5914 8.05901C9.08449 8.05901 10.2949 9.26146 10.2949 10.7447C10.2949 12.2279 9.08449 13.4303 7.5914 13.4303ZM19.0353 10.7447C19.0353 11.0316 18.8018 11.2635 18.5131 11.2635H16.977V12.7894C16.977 13.0763 16.7435 13.3083 16.4547 13.3083C16.1659 13.3083 15.9324 13.0763 15.9324 12.7894V11.2635H14.3963C14.1075 11.2635 13.874 11.0316 13.874 10.7447C13.874 10.4578 14.1075 10.2259 14.3963 10.2259H15.9324V8.69991C15.9324 8.41303 16.1659 8.18109 16.4547 8.18109C16.7435 8.18109 16.977 8.41303 16.977 8.69991V10.2259H18.5131C18.8018 10.2259 19.0353 10.4578 19.0353 10.7447Z"
      fill="white"
    />
  </svg>
);

export const BackgroundFitIcon = ({
  size = 24,
  color = 'currentColor',
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <path
      d="M4.03 21.03a.75.75 0 0 1-1.06-1.06l17-17a.75.75 0 0 1 1.06 1.06l-17 17Zm4.5.5a.75.75 0 0 1-1.06-1.06l13-13a.75.75 0 0 1 1.06 1.06l-13 13Zm5 0a.75.75 0 0 1-1.06-1.06l8-8a.75.75 0 0 1 1.06 1.06l-8 8Zm5.5-.5a.75.75 0 0 1-1.06-1.06l2-2a.75.75 0 0 1 1.06 1.06l-2 2Zm-15.5-4.5a.75.75 0 0 1-1.06-1.06l13-13a.75.75 0 0 1 1.06 1.06l-13 13Zm0-5a.75.75 0 0 1-1.06-1.06l8-8a.75.75 0 0 1 1.06 1.06l-8 8Zm.5-5.5a.75.75 0 0 1-1.06-1.06l2-2a.75.75 0 0 1 1.06 1.06l-2 2Z"
      fill={color}
    ></path>
  </svg>
);

export const ZoomInIcon = ({
  size = 19,
  color = 'currentColor',
}: IIconProps) => {
  return (
    <svg
      fill={color}
      preserveAspectRatio="xMidYMid meet"
      height={size}
      width={size}
      viewBox="0 0 16 16"
      data-cy="zoomInIcon"
    >
      <g>
        <path d="M15.59,13.59l-2.74-2.74a7,7,0,1,0-2,2l2.74,2.74a1.41,1.41,0,0,0,2,0h0A1.41,1.41,0,0,0,15.59,13.59ZM7,12a5,5,0,1,1,5-5A5,5,0,0,1,7,12Z"></path>
        <polygon points="8 4 6 4 6 6 4 6 4 8 6 8 6 10 8 10 8 8 10 8 10 6 8 6 8 4"></polygon>
      </g>
    </svg>
  );
};

export const ZoomOutIcon = ({
  size = 19,
  color = 'currentColor',
}: IIconProps) => {
  return (
    <svg
      fill={color}
      preserveAspectRatio="xMidYMid meet"
      height={size}
      width={size}
      viewBox="0 0 16 16"
      data-cy="zoomOutIcon"
    >
      <g>
        <path d="M15.59,13.59l-2.74-2.74a7,7,0,1,0-2,2l2.74,2.74a1.41,1.41,0,0,0,2,0h0A1.41,1.41,0,0,0,15.59,13.59ZM7,12a5,5,0,1,1,5-5A5,5,0,0,1,7,12Z"></path>
        <rect x="4" y="6" width="6" height="2"></rect>
      </g>
    </svg>
  );
};

export const NoImageIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.83588 4.2565C10.8135 3.15066 13.0657 2.63229 15.3278 2.76231C17.5898 2.89233 19.7678 3.66533 21.6057 4.99047C23.4436 6.31562 24.8651 8.13784 25.7031 10.243C26.541 12.3482 26.7607 14.6488 26.3363 16.8745L16.9963 14.3277C16.2 14.1107 15.3504 14.2148 14.63 14.6176C13.9096 15.0204 13.3761 15.6899 13.1442 16.482L10.4228 25.7736C8.30419 24.9699 6.45901 23.5781 5.10414 21.7619C3.74926 19.9457 2.94099 17.7804 2.77432 15.5206C2.60766 13.2608 3.08953 11.0004 4.16329 9.00505C5.23706 7.00969 6.85809 5.3623 8.83588 4.2565ZM12.4445 26.342L15.1599 17.0714C15.2373 16.8076 15.4151 16.5847 15.655 16.4505C15.8949 16.3164 16.1779 16.2816 16.4431 16.3537L25.7646 18.8932C24.7723 21.5009 22.8919 23.6751 20.4544 25.0329C18.0217 26.3982 15.1853 26.8618 12.4445 26.342ZM26.8665 7.81026C23.0919 1.06038 14.5606 -1.35136 7.81071 2.4233C1.06084 6.19795 -1.3509 14.7292 2.42375 21.4791C6.19841 28.229 14.7297 30.6407 21.4796 26.8661C28.2294 23.0914 30.6412 14.5601 26.8665 7.81026ZM8.96458 13.8105C9.20768 13.6746 9.38682 13.4476 9.46259 13.1796C9.53836 12.9116 9.50455 12.6244 9.36861 12.3813C9.23266 12.1382 9.00571 11.9591 8.73769 11.8833C8.46966 11.8076 8.18252 11.8414 7.93942 11.9773C7.69632 12.1133 7.51718 12.3402 7.44141 12.6082C7.36565 12.8763 7.39945 13.1634 7.5354 13.4065C7.67134 13.6496 7.89829 13.8287 8.16631 13.9045C8.43434 13.9803 8.72148 13.9465 8.96458 13.8105ZM9.98975 15.6437C9.62864 15.8457 9.23129 15.9745 8.82039 16.0229C8.40948 16.0713 7.99308 16.0382 7.59494 15.9257C7.1968 15.8131 6.82473 15.6233 6.49998 15.3669C6.17522 15.1106 5.90413 14.7928 5.70219 14.4317C5.50025 14.0706 5.37141 13.6732 5.32304 13.2623C5.27466 12.8514 5.30769 12.435 5.42024 12.0369C5.53279 11.6387 5.72266 11.2667 5.979 10.9419C6.23534 10.6171 6.55315 10.346 6.91425 10.1441C7.64355 9.73627 8.50499 9.63485 9.30906 9.86216C10.1131 10.0895 10.794 10.6269 11.2018 11.3562C11.6096 12.0855 11.7111 12.9469 11.4838 13.751C11.2565 14.5551 10.719 15.2359 9.98975 15.6437Z"
      fill="#5C5C5C"
      fillOpacity="0.28"
    />
  </svg>
);

export const CameraIcon = ({ size = 40, color = '#ffffff' }: IIconProps) => (
  <svg
    height={size}
    width={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 9.8541C3 8.83011 3.83011 8 4.8541 8V8C5.55638 8 6.19839 7.60322 6.51246 6.97508L7.33333 5.33333C7.44329 5.11342 7.49827 5.00346 7.56062 4.90782C7.8859 4.40882 8.41668 4.08078 9.00848 4.01299C9.1219 4 9.24484 4 9.49071 4H14.5093C14.7552 4 14.8781 4 14.9915 4.01299C15.5833 4.08078 16.1141 4.40882 16.4394 4.90782C16.5017 5.00346 16.5567 5.11342 16.6667 5.33333L17.4875 6.97508C17.8016 7.60322 18.4436 8 19.1459 8V8C20.1699 8 21 8.83011 21 9.8541V14.8571C21 16.8619 21 17.8643 20.5402 18.5961C20.3004 18.9777 19.9777 19.3004 19.5961 19.5402C18.8643 20 17.8619 20 15.8571 20H8.14286C6.1381 20 5.13571 20 4.4039 19.5402C4.02229 19.3004 3.69961 18.9777 3.45983 18.5961C3 17.8643 3 16.8619 3 14.8571V9.8541Z"
      stroke={color}
    />
    <circle cx="12" cy="13" r="3.5" stroke={color} />
  </svg>
);
